import { connect } from "react-redux";
import EquipmentRoutes from "./equipment-routes";
import { onList } from "../actions";

const mapStateToProps = (state) => ({});

const mapDispatchToProps = {
	onGetEquipmentList: onList,
};

export default connect(mapStateToProps, mapDispatchToProps)(EquipmentRoutes);
